import { Component, Input } from '@angular/core';
import { MeetingSchedulingData } from '../../../../shared/models/meetings.model';
import { faCalendarCheck, faVideo, faPen, faXmark, faCalendarPlus } from '@fortawesome/pro-duotone-svg-icons';

@Component({
  selector: 'app-meetings-list',
  templateUrl: './meetings-list.component.html',
  styleUrl: './meetings-list.component.scss',
  standalone: false
})
export class MeetingsListComponent {
  @Input() schedulingData!: MeetingSchedulingData;

  public icons = {
    calendarCheck: faCalendarCheck,
    video: faVideo,
  pen: faPen,
    xmark: faXmark,
    calendarCirclePlus: faCalendarPlus,
  };
}
